import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { renderChatMarkdown } from '../../../core/helpers/chat-markdown.helper';
import { linkifyText } from '../../../core/helpers/linkify-text.helper';

@Component({
  selector: 'logibids-linkified-text',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (heading()) {
      <h3 [class]="textClass()">
        @for (segment of segments(); track $index) {
          @if (segment.type === 'link') {
            <a
              class="chat_link"
              [class.chat_link--email]="segment.kind === 'email'"
              [href]="segment.href"
              [attr.target]="segment.kind === 'url' ? '_blank' : null"
              [attr.rel]="segment.kind === 'url' ? 'noopener noreferrer' : null"
              [attr.aria-label]="segment.label"
            >
              @if (segment.kind === 'url') {
                <i
                  class="pi pi-external-link chat_link_icon"
                  aria-hidden="true"
                ></i>
              } @else {
                <i class="pi pi-envelope chat_link_icon" aria-hidden="true"></i>
              }
              <span class="chat_link_label">{{ segment.label }}</span>
            </a>
          } @else if (
            segment.bold || segment.italic || segment.strike || segment.code
          ) {
            <span
              [class.md_bold]="segment.bold"
              [class.md_italic]="segment.italic"
              [class.md_strike]="segment.strike"
              [class.md_code]="segment.code"
              >{{ segment.value }}</span
            >
          } @else {
            {{ segment.value }}
          }
        }
      </h3>
    } @else {
      <span [class]="textClass()">
        @for (segment of segments(); track $index) {
          @if (segment.type === 'link') {
            <a
              class="chat_link"
              [class.chat_link--email]="segment.kind === 'email'"
              [href]="segment.href"
              [attr.target]="segment.kind === 'url' ? '_blank' : null"
              [attr.rel]="segment.kind === 'url' ? 'noopener noreferrer' : null"
              [attr.aria-label]="segment.label"
            >
              @if (segment.kind === 'url') {
                <i
                  class="pi pi-external-link chat_link_icon"
                  aria-hidden="true"
                ></i>
              } @else {
                <i class="pi pi-envelope chat_link_icon" aria-hidden="true"></i>
              }
              <span class="chat_link_label">{{ segment.label }}</span>
            </a>
          } @else if (
            segment.bold || segment.italic || segment.strike || segment.code
          ) {
            <span
              [class.md_bold]="segment.bold"
              [class.md_italic]="segment.italic"
              [class.md_strike]="segment.strike"
              [class.md_code]="segment.code"
              >{{ segment.value }}</span
            >
          } @else {
            {{ segment.value }}
          }
        }
      </span>
    }
  `,
  styleUrl: './linkified-text.component.scss',
})
export class LinkifiedTextComponent {
  readonly text = input.required<string>();
  readonly textClass = input<string>('');
  readonly heading = input<boolean>(true);
  /** Render light markdown (bold, italic, bullets …) — for AI / agent messages only. */
  readonly markdown = input<boolean>(false);

  readonly segments = computed(() =>
    this.markdown() ? renderChatMarkdown(this.text()) : linkifyText(this.text())
  );
}
